<template>
  <AntennaIcon v-if="antenna == 'Very Good(4G)'" blocks="4" color="green" />
  <AntennaIcon v-else-if="antenna == 4" blocks="4" color="green" />
  <AntennaIcon v-else-if="antenna == 3" blocks="3" color="green" />
  <AntennaIcon v-else-if="antenna == 2" blocks="2" color="orange" />
  <AntennaIcon v-else-if="antenna == 1" blocks="1" color="red" />
</template>
<script>
import AntennaIcon from "@/components/devices/AntennaIcon";
export default {
  components: {
    AntennaIcon,
  },
  props: {
    antenna: {
      type: String,
      require: true,
    },
  },
};
</script>
